import { Box, Typography, Chip, Stack, Paper, useTheme, Divider } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HomeIcon from "@mui/icons-material/Home";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WindowIcon from "@mui/icons-material/Window";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import SecurityIcon from "@mui/icons-material/Security";

interface PropertyOverviewProps {
    data: {
        listed: string;
        views: number;
        overview: string;
        features: string[];
    };
}

// Mapeo de iconos para las características
const featureIcons = [
    LocationOnIcon,
    WindowIcon,
    StarBorderIcon,
    SecurityIcon,
];

export default function PropertyOverview({ data }: PropertyOverviewProps) {
    const theme = useTheme();

    return (
        <Paper
            elevation={2}
            sx={{
                p: { xs: 2, md: 3 },
                mt: 0,
                borderRadius: 3,
                backgroundColor: "background.paper",
                width: "100%",
            }}
        >
            {/* Header Section */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1,
                    flexWrap: "wrap",
                    gap: 2,
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <HomeIcon
                        sx={{
                            fontSize: 32,
                            color: theme.palette.primary.main,
                        }}
                    />
                    <Typography
                        variant="h5"
                        fontWeight="bold"
                        sx={{
                            color: theme.palette.primary.main,
                        }}
                    >
                        Property Overview
                    </Typography>
                </Box>

                <Stack direction="row" spacing={1.5} sx={{ flexWrap: "wrap" }}>
                    <Chip
                        icon={<AccessTimeIcon />}
                        label={data.listed}
                        sx={{
                            backgroundColor: "grey.100",
                            color: "text.secondary",
                        }}
                    />
                    {/*<Chip
                        icon={<VisibilityIcon />}
                        label={`${data.views} views`}
                        sx={{
                            backgroundColor: "grey.100",
                            color: "text.secondary",
                        }}
                    />*/}
                </Stack>
            </Box>

            <Divider sx={{ mb: 3, borderColor: '#f8f4f0', borderBottomWidth: '2px' }} />

            {/* Main Description */}
            <Typography
                variant="body1"
                sx={{
                    color: "text.primary",
                    mb: 3,
                    lineHeight: 1.7,
                    fontSize: "1rem",
                }}
            >
                {data.overview}
            </Typography>

            {/* Feature Boxes Grid */}
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
                    gap: 1,
                }}
            >
                {data.features.map((feature, index) => {
                    const IconComponent = featureIcons[index] || HomeIcon;
                    return (
                        <Paper
                            key={index}
                            elevation={0}
                            sx={{
                                p: { xs: 2, sm: 2.5 },
                                width: "100%",
                                minHeight: { xs: "auto", sm: 160 },
                                backgroundColor: "#f9f4f1",
                                borderRadius: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                transition: "transform 0.2s ease",
                                "&:hover": {
                                    transform: "translateY(-4px)",
                                    boxShadow: 2,
                                },
                            }}
                        >
                            <IconComponent
                                sx={{
                                    fontSize: 40,
                                    color: theme.palette.secondary.main,
                                    mb: 1.5,
                                    flexShrink: 0,
                                }}
                            />
                            <Typography
                                variant="body2"
                                sx={{
                                    color: "text.primary",
                                    fontSize: "0.9rem",
                                    lineHeight: 1.5,
                                    width: "100%",
                                }}
                            >
                                {feature}
                            </Typography>
                        </Paper>
                    );
                })}
            </Box>
        </Paper>
    );
}
